import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/formTemplate/importer/formTemplateImporterSelectors';
import FormTemplateService from 'src/modules/formTemplate/formTemplateService';
import fields from 'src/modules/formTemplate/importer/formTemplateImporterFields';
import { i18n } from 'src/i18n';

const formTemplateImporterActions = importerActions(
  'FORMTEMPLATE_IMPORTER',
  selectors,
  FormTemplateService.import,
  fields,
  i18n('entities.formTemplate.importer.fileName'),
);

export default formTemplateImporterActions;